<template>
	<div>
		
		<div class="stats-container">
		    <div class="stat-item" style="display: none;">
		        <span class="stat-label" >节点总ATM:</span>
		        <span id="totalMineStat" class="stat-value">0</span>
		    </div>
		    <div class="stat-item" style="display: none;">
		        <span class="stat-label" >团队人数:</span>
		        <span id="totalPeopleStat" class="stat-value">0</span>
		    </div>
			<div class="stat-item" style="display: none;">
			    <span class="stat-label">有效人数:</span>
			    <span id="totalPeopleActive" class="stat-value">0</span>
			</div>
			<div class="stat-item" v-if="showButton == true">
			    <button class="glass-btn" @click="startLoad()">开始加载</button>
			</div>
		</div>
		
		<div class="tree-container">
		    <div class="tree-root">
		        <ul id="treeRoot" class="tree" style="display: none;"></ul>
		    </div>
		</div>
		<div id="detailModal" class="team-modal">
			
		    <div class="team-modal-content">
		        
		        <h2>节点详情</h2>
		        <div id="detailContent"></div>
		    </div>
		</div>
		<!-- 返回按钮 -->
		<button class="back-button" @click="handleBackClick" data-lang="t_217">
			
		</button>
	</div>
</template>
	
<script>
	export default {
		name: 'TeamData',
		data() {
			return {
				isLoading: false,
				LastSelect:null,
				isShow:false,
				showButton:true,
				treeData: [],
				nodeList: [], // 用于快速查找节点	
				// 类型映射
				typeMap: [
					 {name: "无效用户", className: "type-normal-user"},
				    {name: "普通矿机用户", className: "type-normal-user"},
				    {name: "普通做市商", className: "type-market-maker"},
				    {name: "创始人矿机", className: "type-founder-miner"},
				    {name: "创始人做市商", className: "type-founder-mm"},
				    {name: "拉黑地址", className: "type-blacklisted"},
				    {name: "转正的创世节点", className: "type-genesis-node"},
				    {name: "转正的创世做市商", className: "type-genesis-mm"}
				]
			}
		},
		mounted() {
			this.setLanguage();
			//this.getNode(Account);
		},
		methods: {
			
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
					
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			handleBackClick() {
				// 设置加载状态
				this.isLoading = true;
				setTimeout(() => {
					// 触发自定义事件，通知父组件
					this.$emit('data-received', {
						message: 'profile',
					});
	
					// 重置加载状态
					this.isLoading = false;
				}, 300);
			},
			btnCopyAddress(addr) { //Copy钱包
				copyRefURL(addr);
			},
			// 主要函数：添加节点到树形结构
			addNodeToTree(node, address) {
			    // 将地址添加到数据中
			    // 将地址添加到数据中
			    const jsonData = { ...node, Address: address };
				
			    const nodeId = jsonData.id.toString();
			    const parentId = jsonData.fatherNode.toString();
			    // 存储节点数据
			    if (!this.treeData[nodeId]) {
			        this.treeData[nodeId] = {
			            data: jsonData,
			            children: []
			        };
			        this.nodeList[nodeId] = this.treeData[nodeId];
			    } else {
			        this.treeData[nodeId].data = jsonData;
			    }
			    
			    // 处理父子关系
			    if (parentId !== "0" && parentId !== nodeId) {
			        if (!this.treeData[parentId]) {
			            this.treeData[parentId] = {
			                data: null,
			                children: [nodeId]
			            };
			            this.nodeList[parentId] = this.treeData[parentId];
			        } else if (!this.treeData[parentId].children.includes(nodeId)) {
			            this.treeData[parentId].children.push(nodeId);
			        }
			    }
			    
			    // 重新渲染树
			    this.renderTree();
			    
			    // 更新统计数据
			    this.updateStats();
				
			},
			renderTree() {
			    const treeRoot = document.getElementById('treeRoot');
			    treeRoot.innerHTML = '';
			    
			    // 找到根节点（没有父节点或父节点为0的节点）
			    const rootNodes = [];
			    for (let id in this.treeData) {
			        const node = this.treeData[id];
			        const parentId = node.data ? node.data.fatherNode.toString() : "0";
			        
			        if (parentId === "0" || parentId === id || !this.treeData[parentId]) {
			            rootNodes.push(id);
			        }
			    }
			    
			    // 渲染根节点
			    rootNodes.forEach(rootId => {
					
			        const rootNode = this.createNodeElement(rootId);
					
			        if (rootNode) {
			            treeRoot.appendChild(rootNode);
			        }
			    });
				
			},
			updateStats() {
				
			    let totalMine = 0;
			    let totalPeople = 0;
			    let totalPeopleActive=0;
			    for (let id in this.treeData) {
					if(this.treeData[id].data){
						totalMine += this.treeData[id].data.totalMine /100 || 0 ;
						totalPeople += parseInt(this.treeData[id].data.people) || 0;
						if(this.treeData[id].data.totalMine > 0 && this.treeData[id].data.totalMine != 3000000)totalPeopleActive ++;
					}
			        
			    }
			    totalMine = Math.floor(totalMine) / 10000;
			    document.getElementById('totalMineStat').textContent = totalMine + " 万";
			    document.getElementById('totalPeopleStat').textContent = totalPeople;
				document.getElementById("totalPeopleActive").textContent = totalPeopleActive + " 人";
			},
			createNodeElement(nodeId) {
			    const node = this.treeData[nodeId];
				
			    if (!node) return null;
				if(!node.data)return null;
			    const li = document.createElement('li');
			    li.className = 'tree-node';
			    li.dataset.nodeId = nodeId;
			
			    const div = document.createElement('div');
			    div.className = 'node-content';
			
			    const toggleBtn = document.createElement('button');
			    toggleBtn.className = 'toggle-btn';
			    toggleBtn.textContent = '+';
			    toggleBtn.style.visibility = node.children && node.children.length > 0 ? 'visible' : 'hidden';
			
			    const span = document.createElement('span');
			    span.className = 'node-text';
			    span.innerHTML = `${node.data.Address.substring(0,6)+"..."+node.data.Address.substring(38,42)}
				 【 ${Number(node.data.id).toString(16).toUpperCase()} 】
				   ${node.data.Type == 3?"【创世节点】":"" } 
				 `;
			   
			    // 根据类型设置颜色
			    if (this.typeMap[node.data.Type]) {
			        span.className += ' ' + this.typeMap[node.data.Type].className;
			    }
			
			    div.appendChild(toggleBtn);
			    div.appendChild(span);
			    li.appendChild(div);
			
			    // 添加子节点容器
			    const ul = document.createElement('ul');
			    ul.className = 'children';
			    li.appendChild(ul);
				
			    // 事件监听
				toggleBtn.addEventListener('click', (e) => {
				  e.stopPropagation();
				  this.toggleChildren(nodeId);
				});
				
			    
			
			    div.addEventListener('click',(e)=> {
					div.style.backgroundColor="#AAAAAA";
					//div.style.color = "#FFF";
					if(this.LastSelect !=null){
						this.LastSelect.style.backgroundColor="#fff";
						//LastSelect.style.color = "#000";
					}
					this.LastSelect = div;
			        this.showDetail(node.data);
			    });
			
			    return li;
			},
			toggleChildren(nodeId) {
			    const node = this.treeData[nodeId];
			    const li = document.querySelector(`[data-node-id="${nodeId}"]`);
			    const childrenUl = li.querySelector('.children');
			    const toggleBtn = li.querySelector('.toggle-btn');
			
			    if (childrenUl.classList.contains('expanded')) {
			        childrenUl.classList.remove('expanded');
			        toggleBtn.textContent = '+';
			    } else {
			        childrenUl.classList.add('expanded');
			        toggleBtn.textContent = '-';
			        
			        // 动态加载子节点
			        if (node.children && node.children.length > 0) {
			            this.renderChildren(nodeId);
			        }
			    }
			},
			renderChildren(parentId) {
				
			    const parent = this.treeData[parentId];
			    const li = document.querySelector(`[data-node-id="${parentId}"]`);
			    const childrenUl = li.querySelector('.children');
			    
			    // 清空现有子节点
			    childrenUl.innerHTML = '';
			    
			    if (parent.children && parent.children.length > 0) {
			        parent.children.forEach(childId => {
			            const childLi = this.createNodeElement(childId);
			            if (childLi) {
			                childrenUl.appendChild(childLi);
			            }
			        });
			    }
			},
			showDetail(data) {
			    const modal = document.getElementById('detailModal');
			    const content = document.getElementById('detailContent');
			    
			    content.innerHTML = `
			        <div class="detail-item">
			            <span class="detail-label">地址:</span>
			            <span class="detail-value">${data.Address}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">ID:</span>
			            <span class="detail-value">${Number(data.id).toString(16).toUpperCase()}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">父节点:</span>
			            <span class="detail-value">${ Number(data.fatherNode).toString(16).toUpperCase()}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">直推人数:</span>
			            <span class="detail-value">${data.people}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">矿机代币:</span>
			            <span class="detail-value">${data.totalMine/100}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">加速度:</span>
			            <span class="detail-value">${data.speed/100}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">类别:</span>
			            <span class="detail-value">${this.typeMap[data.Type] ? this.typeMap[data.Type].name : data.Type}</span>
			        </div>
			        <div class="detail-item">
			            <span class="detail-label">内盘余额:</span>
			            <span class="detail-value">${data.balanceOf/100}</span>
			        </div>
			    `;
			    
			    modal.style.display = 'block';
			},
			async getNode(address,isFirst = false){//获得当前节点的数据
				//alert(address)
			
				let node =await conMine.getPeopleTree(address).call();
				
				this.addNodeToTree(node,address);
				
				//uint32 childNode;//子节点
				//uint32 brotherNode;//兄弟结点
				//如果有兄弟节点，就访问所有兄弟节点
				if(node.brotherNode > 0 && isFirst == false){
					let addr = await conMine.getFindAddressFromId(node.brotherNode).call();
					
					this.getNode(addr,false);
				}
				if(node.childNode > 0){
					let addr = await conMine.getFindAddressFromId(node.childNode).call();
					
					this.getNode(addr,false);
				} 
				
				if(node.brotherNode == 0 && node.childNode == 0){
					this.isShow = true;
					var that = this;
					setTimeout(function(){
						if(that.isShow == true){
							document.getElementById("treeRoot").style.display = "block";
						}
					},1000)
					
				}else{
					this.isShow = false;
				}
			},
			startLoad(){
				this.getNode(Account,true);
				//this.getNode("0x3C5E4A9AB218979EA712268FcE24c71137785cB2",true);
				this.showButton = false;
			}
		},
		
	}
</script>

<style>
	
	.back-button {
		margin-top: 5rem;
		display: block;
		width: 100%;
		padding: 14px;
		background: rgba(255, 255, 255, 0.05);
		border: 1px solid #333;
		border-radius: 8px;
		color: #adb5bd;
		font-size: 1rem;
		cursor: pointer;
		transition: all 0.3s ease;
	}
	
	.back-button:hover {
		background: rgba(255, 255, 255, 0.1);
		border-color: #4dabf7;
		color: #4dabf7;
	}
        
        .stats-container {
            background: white;
            border-radius: 8px;
            padding: 15px;
            margin-bottom: 20px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
			text-align: center;
			display: grid;
			grid-template-columns: 1fr 1fr; /* 两列等宽 */
        }

        .stat-item {
            display: inline-block;
            margin-right: 30px;
        }

        .stat-label {
            font-weight: bold;
            color: #333;
        }

        .stat-value {
            font-size: 18px;
            color: #007bff;
        }

        .tree-container {
            /*background: white;*/
            border-radius: 8px;
            padding: 15px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            overflow-x: auto;
            white-space: nowrap;
            max-width: 100vw;
        }

        .tree-root {
            display: inline-block;
            min-width: 100%;
        }

        .tree-node {
            list-style-type: none;
            margin: 5px 0;
            position: relative;
            padding-left: 20px;
        }

        .tree-node:before {
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 1px;
            background-color: #ccc;
        }

        .tree-node:after {
            content: "";
            position: absolute;
            top: 10px;
            left: 0;
            width: 10px;
            height: 1px;
            background-color: #ccc;
        }

        .tree-node:first-child:before {
            top: 10px;
        }

        .tree-node:last-child:before {
            height: 10px;
        }

        .node-content {
            display: flex;
            align-items: center;
            padding: 5px 10px;
            background: #f8f9fa;
            border-radius: 4px;
            cursor: pointer;
            user-select: none;
            transition: background-color 0.2s;
        }

        .node-content:hover {
            background-color: #e9ecef;
        }

        .toggle-btn {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            background: #007bff;
            color: white;
            border: none;
            border-radius: 50%;
            font-size: 12px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .node-text {
            font-size: 14px;
        }

        .children {
            margin-left: 20px;
            display: none;
        }

        .children.expanded {
            display: block;
        }

        .team-modal {
            /*display: none;
            position: fixed;*/
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            z-index: 1000;
        }

        .team-modal-content {
            /*background-color: white;*/
            
            padding: 20px;
            border-radius: 8px;
            width: 90%;
            max-width: 500px;
            box-shadow: 0 4px 20px rgba(0,0,0,0.3);
        }
/*
        .close {
            float: right;
            cursor: pointer;
            font-size: 24px;
            font-weight: bold;
        }
*/
        .detail-item {
            margin: 10px 0;
            padding: 5px 0;
            border-bottom: 1px solid #eee;
        }

        .detail-label {
            font-weight: bold;
            color: #007bff;
        }

        .detail-value {
            margin-left: 10px;
            color: #ffc107;
        }

        .type-normal-user { color: #007bff; }
        .type-market-maker { color: #28a745; }
        .type-founder-miner { color: #ffc107; }
        .type-founder-mm { color: #fd7e14; }
        .type-blacklisted { color: #dc3545; }
        .type-genesis-node { color: #6f42c1; }
        .type-genesis-mm { color: #e83e8c; }
		
    </style>
